
export enum Operator {
    BLANK_EMPTY_STRING = "US",
    CONTAINS = "CO",
    EQUALS = "EQ",
    NOT_BLANK_EMPTY_STRING = "FS",
    NOT_CONTAINS = "NC",
    NOT_EQUALS = "NE",
    NOT_MATCHES =  "NM",
    MATCHES = "RE",
    INCLUDES_ANY = "IA",
    NOT_INCLUDES_ANY = "NI",
    LESS_THAN = "LT",
    LESS_EQUAL = "LE",
    GREATER_THAN = "GT",
    GREATER_EQUAL = "GE",
    RANGE = "RANGE",
    WITHIN = "WITHIN",
}